import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faSync, faQrcode, faPrint, faCopy, faCheck, faSearch, faTable, faUtensils, faCheckCircle, faTimesCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import NewMesa from '../NewMesa/NewMesa';
import './MesasData.css';
import moneda from '../../moneda';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default function MesasData() {
    const [mesas, setMesas] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('todas');
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoEstado, setNuevoEstado] = useState('');
    const [nuevoEstadoPedido, setNuevoEstadoPedido] = useState('');
    const [nuevaMesa, setNuevaMesa] = useState('');
    const [mesa, setMesa] = useState({});
    const [selectedSection, setSelectedSection] = useState('texto');
    const [pedidos, setPedidos] = useState([]);
    const [pedido, setPedido] = useState({});
    const [numeroTelefono, setNumeroTelefono] = useState('');
    const [qrModalVisible, setQrModalVisible] = useState(false);
    const [mesaQR, setMesaQR] = useState(null);
    const [copiado, setCopiado] = useState(false);

    useEffect(() => {
        cargarMesas();
        cargarPedidos();
    }, []);

    const cargarPedidos = () => {
        fetch(`${baseURL}/pedidoGet.php`)
            .then(res => res.json())
            .then(data => {
                setPedidos(data.pedidos ? data.pedidos.reverse() : []);
            })
            .catch(error => console.error('Error al cargar pedidos:', error));
    };

    const cargarMesas = () => {
        fetch(`${baseURL}/mesaGet.php`)
            .then(res => res.json())
            .then(data => {
                setMesas(data.mesas || []);
            })
            .catch(error => console.error('Error al cargar mesas:', error));
    };

    const abrirModalQR = (item) => {
        setMesaQR(item);
        setCopiado(false);
        setQrModalVisible(true);
    };

    const cerrarModalQR = () => {
        setQrModalVisible(false);
        setMesaQR(null);
        setCopiado(false);
    };

    const copiarEnlaceQR = (url) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(() => {
                setCopiado(true);
                setTimeout(() => setCopiado(false), 2500);
            });
        } else {
            const input = document.createElement('textarea');
            input.value = url;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            setCopiado(true);
            setTimeout(() => setCopiado(false), 2500);
        }
    };

    const imprimirTarjeta = () => {
        window.print();
    };

    const eliminar = (idMesa) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡Esta acción eliminará la mesa!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/mesaDelete.php?idMesa=${idMesa}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarMesas();
                    })
                    .catch(error => {
                        toast.error(error.message);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setMesa(item);
        setNuevoEstado(item.estado);
        setNuevaMesa(item.mesa);

        const mesaPedidos = pedidos.filter(p => p.idMesa === item.idMesa && p.estado !== "Pagado" && p.estado !== "Rechazado");
        if (mesaPedidos.length > 0) {
            setPedido(mesaPedidos[0]);
            setNuevoEstadoPedido(mesaPedidos[0].estado);
        } else {
            setPedido({});
            setNuevoEstadoPedido('');
        }
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const handleUpdateText = (idMesa) => {
        const payload = {
            estado: nuevoEstado !== '' ? nuevoEstado : mesa.estado,
            mesa: nuevaMesa !== '' ? nuevaMesa : mesa.mesa,
        };

        fetch(`${baseURL}/mesaPut.php?idMesa=${idMesa}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error', data.error, 'error');
                } else {
                    Swal.fire('¡Actualizado!', data.mensaje, 'success');
                    cargarMesas();
                    cerrarModal();
                }
            })
            .catch(error => toast.error(error.message));
    };

    const handleUpdateTextPedido = (idPedido) => {
        const payload = {
            estado: nuevoEstadoPedido !== '' ? nuevoEstadoPedido : pedido.estado,
        };

        fetch(`${baseURL}/pedidoPut.php?idPedido=${idPedido}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    Swal.fire('Error', data.error, 'error');
                } else {
                    Swal.fire('¡Actualizado!', data.mensaje, 'success');
                    cargarPedidos();
                    cargarMesas();
                    cerrarModal();
                }
            })
            .catch(error => toast.error(error.message));
    };

    const handleDownloadPDF = () => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        let y = 15;
        pdf.setFontSize(14);
        pdf.text("Detalle de Pedido - Mesa", 14, y);
        y += 8;

        const pedidoActual = pedido;
        const mesaFiltrada = mesas.find(m => m.idMesa === pedidoActual?.idMesa);

        const pedidoData = [
            ['ID Pedido:', `${pedidoActual.idPedido}`],
            ['Mesa:', `${mesaFiltrada?.mesa || 'N/A'}`],
            ['Estado:', `${pedidoActual.estado}`],
            ['Cliente:', `${pedidoActual.nombre}`],
            ['Nota:', `${pedidoActual.nota || 'Ninguna'}`],
            ['Total:', `${moneda} ${pedidoActual.total}`],
            ['Fecha:', `${pedidoActual.createdAt}`]
        ];

        pdf.autoTable({
            startY: y,
            head: [['Detalle del Pedido', 'Información']],
            body: pedidoData,
        });

        pdf.save(`pedido_${pedidoActual.idPedido}.pdf`);
    };

    const handleEnviarWhatsApp = (pedidoParam) => {
        if (!numeroTelefono) {
            toast.warn('Por favor, ingresa un número de teléfono');
            return;
        }
        let mensajeWpp = `*Detalle de Pedido #${pedidoParam?.idPedido}*\nCliente: ${pedidoParam?.nombre || 'Estimado'}\nTotal: ${moneda} ${pedidoParam?.total}\n`;
        const url = `https://api.whatsapp.com/send?phone=${numeroTelefono.replace(/\D/g, '')}&text=${encodeURIComponent(mensajeWpp)}`;
        window.open(url, '_blank');
    };

    // Métricas
    const totalMesas = mesas.length;
    const mesasLibres = mesas.filter(m => m.estado === 'libre').length;
    const mesasOcupadas = mesas.filter(m => m.estado === 'ocupada').length;

    // Filtros
    const mesasFiltradas = mesas.filter(m => {
        const coincideBusqueda = (m.mesa || '').toLowerCase().includes(busqueda.toLowerCase());
        const coincideEstado = filtroEstado === 'todas' || m.estado === filtroEstado;
        return coincideBusqueda && coincideEstado;
    });

    return (
        <div className="adminPageContainer">
            <ToastContainer />

            {/* Cabecera Principal */}
            <div className="adminHeaderSection">
                <div className="adminHeaderTitle">
                    <h2><FontAwesomeIcon icon={faTable} /> Gestión de Mesas y Códigos QR</h2>
                    <p>Administra las mesas del restaurante, genera códigos QR únicos y consulta el estado de ocupación.</p>
                </div>
                <div className="adminHeaderActions">
                    <NewMesa onMesaCreated={() => { cargarMesas(); cargarPedidos(); }} />
                    <button className="adminActionBtn" onClick={() => { cargarMesas(); cargarPedidos(); }} title="Recargar mesas">
                        <FontAwesomeIcon icon={faSync} />
                    </button>
                </div>
            </div>

            {/* Tarjetas de Métricas de Mesas */}
            <div className="adminKpisMiniGrid">
                <div className="adminKpiMiniCard">
                    <span>Total de Mesas</span>
                    <strong>{totalMesas} mesas</strong>
                </div>
                <div className="adminKpiMiniCard kpiSuccess">
                    <span>Mesas Libres</span>
                    <strong>{mesasLibres} disponibles</strong>
                </div>
                <div className="adminKpiMiniCard kpiWarning">
                    <span>Mesas Ocupadas</span>
                    <strong>{mesasOcupadas} en servicio</strong>
                </div>
            </div>

            {/* Barra de Búsqueda y Filtros */}
            <div className="adminToolbar">
                <div className="adminSearchBox">
                    <FontAwesomeIcon icon={faSearch} />
                    <input
                        type="text"
                        placeholder="Buscar por número o nombre de mesa..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                </div>

                <div className="adminFiltersRow">
                    <button
                        className={`adminFilterPill ${filtroEstado === 'todas' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('todas')}
                    >
                        Todas ({totalMesas})
                    </button>
                    <button
                        className={`adminFilterPill ${filtroEstado === 'libre' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('libre')}
                    >
                        Libres ({mesasLibres})
                    </button>
                    <button
                        className={`adminFilterPill ${filtroEstado === 'ocupada' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('ocupada')}
                    >
                        Ocupadas ({mesasOcupadas})
                    </button>
                </div>
            </div>

            {/* Modal Código QR */}
            {qrModalVisible && mesaQR && (
                <div className="adminModalOverlay" onClick={cerrarModalQR}>
                    <div className="adminModalContent modalSmallSimple printable-qr-card" onClick={(e) => e.stopPropagation()}>
                        <div className="adminModalHeader no-print">
                            <h3><FontAwesomeIcon icon={faQrcode} /> Tarjeta QR - {mesaQR.mesa}</h3>
                            <button type="button" className="adminModalClose" onClick={cerrarModalQR}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <div className="adminModalBody">
                            <div className="qr-card-body">
                                <div className="qr-print-header">
                                    <h2>🍽️ Menú Digital</h2>
                                    <p className="qr-table-badge">Mesa: <strong>{mesaQR.mesa}</strong></p>
                                </div>

                                {(() => {
                                    const targetUrl = `${window.location.origin}/?mesaToken=${mesaQR.token || ''}`;
                                    const qrImgSrc = `https://api.qrserver.com/v1/create-qr-code/?size=260x260&margin=10&data=${encodeURIComponent(targetUrl)}`;
                                    return (
                                        <>
                                            <div className="qr-image-wrapper">
                                                <img src={qrImgSrc} alt={`QR Mesa ${mesaQR.mesa}`} className="qr-image-display" />
                                            </div>

                                            <p className="qr-instructions">
                                                Escanea con tu celular para ver nuestra carta, realizar tus pedidos y llamar al mesero.
                                            </p>

                                            <div className="qr-url-box no-print">
                                                <input type="text" readOnly value={targetUrl} className="qr-url-input" />
                                                <button type="button" className="adminBtnSecondary" onClick={() => copiarEnlaceQR(targetUrl)}>
                                                    <FontAwesomeIcon icon={copiado ? faCheck : faCopy} /> {copiado ? 'Copiado' : 'Copiar'}
                                                </button>
                                            </div>
                                        </>
                                    );
                                })()}
                            </div>
                        </div>

                        <div className="adminModalFooter no-print">
                            <button type="button" className="adminBtnSecondary" onClick={cerrarModalQR}>
                                Cerrar
                            </button>
                            <button type="button" className="adminBtnPrimary" onClick={imprimirTarjeta}>
                                <FontAwesomeIcon icon={faPrint} /> Imprimir Tarjeta
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Editar Mesa / Ver Pedido */}
            {modalVisible && (
                <div className="adminModalOverlay" onClick={cerrarModal}>
                    <div className="adminModalContent modalMesaEditContent" onClick={(e) => e.stopPropagation()}>
                        <div className="adminModalHeader">
                            <div className="modalProductTabs">
                                <button
                                    type="button"
                                    className={`modalTabBtn ${selectedSection === 'texto' ? 'active' : ''}`}
                                    onClick={() => setSelectedSection('texto')}
                                >
                                    <FontAwesomeIcon icon={faTable} /> Editar Mesa
                                </button>
                                <button
                                    type="button"
                                    className={`modalTabBtn ${selectedSection === 'pedido' ? 'active' : ''}`}
                                    onClick={() => setSelectedSection('pedido')}
                                >
                                    <FontAwesomeIcon icon={faUtensils} /> Comanda Actual
                                </button>
                            </div>
                            <button type="button" className="adminModalClose" onClick={cerrarModal}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <div className="adminModalBody">
                            {selectedSection === 'texto' && (
                                <div className="sectionEditMesa">
                                    <div className="adminFormField">
                                        <label>Nombre / Número de Mesa:</label>
                                        <input
                                            type="text"
                                            value={nuevaMesa !== '' ? nuevaMesa : mesa.mesa}
                                            onChange={(e) => setNuevaMesa(e.target.value)}
                                            placeholder="Ej: Mesa 1"
                                            autoFocus
                                        />
                                    </div>

                                    <div className="adminFormField">
                                        <label>Estado de Ocupación:</label>
                                        <select
                                            value={nuevoEstado !== '' ? nuevoEstado : mesa.estado}
                                            onChange={(e) => setNuevoEstado(e.target.value)}
                                        >
                                            <option value="libre">Libre (Disponible)</option>
                                            <option value="ocupada">Ocupada (En servicio)</option>
                                        </select>
                                    </div>
                                </div>
                            )}

                            {selectedSection === 'pedido' && (
                                <div className="sectionPedidoMesa">
                                    {pedido && pedido.idPedido ? (
                                        <div className="pedidoActivoDetalle">
                                            <div className="pedidoMetaGrid">
                                                <div>
                                                    <small>ID Pedido:</small>
                                                    <strong>#{pedido.idPedido}</strong>
                                                </div>
                                                <div>
                                                    <small>Cliente:</small>
                                                    <strong>{pedido.nombre || 'No especificado'}</strong>
                                                </div>
                                                <div>
                                                    <small>Total:</small>
                                                    <strong>{moneda} {pedido.total}</strong>
                                                </div>
                                                <div>
                                                    <small>Estado Pedido:</small>
                                                    <select
                                                        value={nuevoEstadoPedido !== '' ? nuevoEstadoPedido : pedido.estado}
                                                        onChange={(e) => setNuevoEstadoPedido(e.target.value)}
                                                        className="selectEstadoPedidoMesa"
                                                    >
                                                        <option value={pedido.estado}>{pedido.estado}</option>
                                                        <option value="Pendiente">Pendiente</option>
                                                        <option value="En preparación">En preparación</option>
                                                        <option value="Listo">Listo</option>
                                                        <option value="Entregado">Entregado</option>
                                                        <option value="Rechazado">Rechazado</option>
                                                        <option value="Pagado">Pagado</option>
                                                    </select>
                                                </div>
                                            </div>

                                            {pedido.nota && (
                                                <div className="notaMesaPedido">
                                                    <strong>Nota:</strong> {pedido.nota}
                                                </div>
                                            )}

                                            <div className="productosMesaList">
                                                {pedido.productos && JSON.parse(pedido.productos).map((prod, idx) => (
                                                    <div key={idx} className="prodMesaRow">
                                                        <span>x{prod.cantidad} {prod.titulo}</span>
                                                        <strong>{moneda} {prod.precio}</strong>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="wppSendSection">
                                                <input
                                                    type="text"
                                                    placeholder="Teléfono para enviar por WhatsApp"
                                                    value={numeroTelefono}
                                                    onChange={(e) => setNumeroTelefono(e.target.value)}
                                                />
                                                <button type="button" className="adminBtnPrimary" onClick={() => handleEnviarWhatsApp(pedido)}>
                                                    Enviar WhatsApp
                                                </button>
                                            </div>

                                            <div className="modalPedidoActions">
                                                <button type="button" onClick={handleDownloadPDF} className="adminBtnSecondary">
                                                    Descargar PDF
                                                </button>
                                                <button type="button" onClick={() => handleUpdateTextPedido(pedido.idPedido)} className="adminBtnPrimary">
                                                    Actualizar Pedido
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="noPedidoActivo">
                                            <FontAwesomeIcon icon={faUtensils} />
                                            <p>Esta mesa no tiene pedidos activos en este momento.</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {selectedSection === 'texto' && (
                            <div className="adminModalFooter">
                                <button type="button" className="adminBtnSecondary" onClick={cerrarModal}>
                                    Cancelar
                                </button>
                                <button type="button" className="adminBtnPrimary" onClick={() => handleUpdateText(mesa.idMesa)}>
                                    Guardar Cambios
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Grilla de Tarjetas de Mesas */}
            <div className="mesasCardsGrid">
                {mesasFiltradas.length === 0 ? (
                    <div className="noMesasFound">No se encontraron mesas con los filtros seleccionados.</div>
                ) : (
                    mesasFiltradas.map(item => {
                        const esLibre = item.estado === 'libre';
                        const pedidoActual = pedidos.find(p => p.idMesa === item.idMesa && p.estado !== 'Pagado' && p.estado !== 'Rechazado');
                        return (
                            <div className={`modernMesaCard ${esLibre ? 'cardLibre' : 'cardOcupada'}`} key={item.idMesa}>
                                <div className="mesaCardTop">
                                    <span className={`statusPill ${esLibre ? 'pillLibre' : 'pillOcupada'}`}>
                                        <FontAwesomeIcon icon={esLibre ? faCheckCircle : faTimesCircle} /> {item.estado}
                                    </span>
                                    <div className="adminActionBtnGroup">
                                        <button className="btnTableAction btn-qr" onClick={() => abrirModalQR(item)} title="Código QR">
                                            <FontAwesomeIcon icon={faQrcode} />
                                        </button>
                                        <button className="btnTableAction btnEditar" onClick={() => abrirModal(item)} title="Editar / Ver Pedido">
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button className="btnTableAction btnBorrar" onClick={() => eliminar(item.idMesa)} title="Eliminar mesa">
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </div>
                                </div>

                                <div className="mesaCardBody">
                                    <h3>{item.mesa}</h3>
                                    {pedidoActual ? (
                                        <div className="mesaOrderPreviewBox">
                                            <span>Pedido #{pedidoActual.idPedido} • {pedidoActual.estado}</span>
                                            <strong>{moneda} {pedidoActual.total}</strong>
                                        </div>
                                    ) : (
                                        <span className="mesaDisponibleText">Disponible para clientes</span>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}
